import { IApplicationState } from '../../types/redux';

export const getIsAnonymous = (state: IApplicationState): boolean => {
  return !!state.newAnswer.data.isAnonymous;
};
